import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/',
  //   component: () => import('../views/home/home.vue'),
  //   redirect: 'home',
  // },
  {
    path: '/',
    component: () => import('../views/home/home.vue'),
    redirect: 'dialogue',
    children: [
      {
        path: 'dialogue',
        name: 'dialogue',
        component: () => import('../views/dialogue/dialogue.vue')
      },
      {
        path: 'my',
        name: 'my',
        component: () => import('../views/my/my.vue')
      },
      {
        path: 'assistant',
        name: 'assistant',
        component: () => import('../views/assistant/assistant.vue')
      },
      {
        path: 'intelligentBody',
        name: 'intelligentBody',
        component: () => import('../views/intelligentBody/intelligentBody.vue')
      },
      {
        path: 'classroom',
        name: 'classroom',
        component: () => import('../views/classroom/classroom.vue')
      },
      {
        path: 'classroomDetail',
        name: 'classroomDetail',
        component: () => import('../views/classroom/classroomDetail.vue')
      },
      {
        path: 'classroomInfo',
        name: 'classroomInfo',
        component: () => import('../views/classroom/classroomInfo.vue')
      },
      {
        path: 'classroomInfo1',
        name: 'classroomInfo1',
        component: () => import('../views/classroom/classroomInfo1.vue')
      },
      {
        path: 'classList',
        name: 'classList',
        component: () => import('../views/class/classList.vue')
      },
      {
        path: 'classDetail',
        name: 'classDetail',
        component: () => import('../views/class/classDetail.vue')
      },
      {
        path: 'simultaneousInterpretation',
        name: 'simultaneousInterpretation',
        component: () => import('../views/classroom/simultaneousInterpretation.vue')
      },
      {
        path: 'simultaneousInterpretationRecord',
        name: 'simultaneousInterpretationRecord',
        component: () => import('../views/classroom/simultaneousInterpretationRecord.vue')
      },
      {
        path: 'simultaneousInterpretationInfo',
        name: 'simultaneousInterpretationInfo',
        component: () => import('../views/classroom/simultaneousInterpretationInfo.vue')
      },
      {
        path: 'resource',
        name: 'resource',
        component: () => import('../views/resource/resource.vue')
      },
      {
        path: 'intelligentBodyChat',
        name: 'intelligentBodyChat',
        component: () => import('../views/intelligentBody/intelligentBodyChat.vue')
      },
      {
        path: 'callWord',
        name: 'callWord',
        component: () => import('../views/assistant/callWord.vue')
      },
      {
        path: 'chat',
        name: 'chat',
        component: () => import('../views/assistant/chat.vue')
      },
      {
        path: 'classroomIntelligentBody',
        name: 'classroomIntelligentBody',
        component: () => import('../views/classroomIntelligentBody/classroomIntelligentBody.vue')
      },
      {
        path: 'createClassroomIntelligentBody',
        name: 'createClassroomIntelligentBody',
        component: () => import('../views/classroomIntelligentBody/createClassroomIntelligentBody.vue')
      },
      // 
      {
        path: 'trClassroom',
        name: 'trClassroom',
        component: () => import('../views/teachingResearch/classroom.vue')
      },
      {
        path: 'trClassroomDetail',
        name: 'trClassroomDetail',
        component: () => import('../views/teachingResearch/classroomDetail.vue')
      },
      {
        path: 'trClassroomInfo',
        name: 'trClassroomInfo',
        component: () => import('../views/teachingResearch/classroomInfo.vue')
      },
      {
        path: 'dimension',
        name: 'dimension',
        component: () => import('../views/teachingResearch/dimension.vue')
      }
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login.vue')
  },
  {
    path: '/xs',
    name: 'xs',
    component: () => import('../views/xs.vue')
  }
]


const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, saveTop) {
    if (saveTop) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve(saveTop)
        }, 1000)
      })
      // return saveTop
    } else {
      return { x: 0, y: 0 }
    }
  },
})

// 前置路由守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token');
  // next();
  if (to.path !== '/login' && !token) {
    next('/login');
  } else {
    next();
  }
})


export default router
